<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="primary">
          <span style="color: #fff" class="text-h5">Duplicar Aula Polivalencia</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
              <form
                @submit.prevent="handleSubmit(enableSubmit)"
                :disabled="false"
                id="form-duplicar-aula"
              >
                <v-row>
                  <v-col class="pt-4 pb-0" cols="12">
                    <e-label class="font-weight-medium" id="label-tipo-aula">Tipo de Aula</e-label>
                    <p class="font-weight-regular" id="tipo-aula">
                      {{ aulaDuplicada.tipo_de_aula }}
                    </p>
                  </v-col>

                  <v-col class="pt-0 pb-0" :cols="12" :sm="4">
                    <ValidationProvider name="Data" rules="required" v-slot="{ errors }">
                      <v-dialog
                        ref="dialog"
                        v-model="modal"
                        :return-value.sync="date"
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <e-label id="label-selecione-data">Selecione uma data</e-label>
                          <v-text-field
                            dense
                            solo
                            v-model="data"
                            label="data"
                            v-bind="attrs"
                            v-on="on"
                            id="campo-data"
                            :error-messages="errors"
                            autocomplete="off"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          color="primary"
                          v-model="dataAulaDuplicada"
                          scrollable
                          :allowedDates="allowedDates"
                          id="seletor-data"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="modal = false" id="btn-cancelar-data">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.dialog.save(date)"
                            id="btn-confirmar-data"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-dialog>
                    </ValidationProvider>
                  </v-col>

                  <v-col
                    class="pt-0 pb-0"
                    v-if="aulaDuplicada.tipo_de_aula !== 'Aula Remota'"
                    cols="6"
                  >
                    <ValidationProvider name="Horário da aula" rules="required" v-slot="{ errors }">
                      <e-label id="label-selecione-horario">Selecione um horário</e-label>
                      <e-autocomplete
                        :items="horarios"
                        :error-messages="errors"
                        label="Selecione uma opção"
                        :item-text="(item) => item.descricao"
                        v-model="horarioSelecionado"
                        return-object
                        dense
                        id="campo-horario"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <div class="mt-4 mb-2">
                  <e-label class="font-weight-medium mb-5">Conteúdos:</e-label>
                </div>
                <v-row>
                  <v-col
                    v-for="(conteudo, index) in JSON.parse(aulaDuplicada.conteudo_polivalencia)"
                    :key="index"
                    cols="12"
                    md="6"
                  >
                    <v-card outlined class="pa-3 rounded-lg">
                      <h3 class="text-primary mb-2">
                        {{ aulaDuplicada.disciplinas_com_descricao[index]?.descricao }}
                      </h3>
                      <div v-html="conteudo.replace(/\n/g, '<br>')"></div>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <e-label class="font-weight-medium mb-5">Metodologia</e-label>
                    <div
                      class="font-weight-regular"
                      v-html="formatarQuebrasDeLinha(aulaDuplicada.metodologia)"
                    ></div>
                  </v-col>
                </v-row>

                <v-divider class="my-6"></v-divider>
                <e-progresso-preenchimento
                  :expectedItems="itemsEsperados"
                  :filledItems="itemsPreenchidos"
                  @total-filled-changed="
                    (value) => $checkTotallyFilled(value, 'totalmentePreenchido')
                  "
                />

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    style="color: #fff"
                    class="red darken-1"
                    @click="$emit('dialogChange', false), limparCampos()"
                    id="btn-fechar-modal"
                  >
                    Fechar
                  </v-btn>
                  <v-btn
                    style="color: #fff"
                    class="green darken-1"
                    type="submit"
                    id="btn-salvar-modal"
                    :disabled="!totalmentePreenchido"
                  >
                    Salvar
                  </v-btn>
                </v-card-actions>
              </form>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="duplicarAula"
      id="modal-confirmacao"
    >
    </e-modal-confirm>
  </v-row>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    submittingForm: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      require: true,
    },
    gestaoDeAulas: {
      type: Object,
      require: true,
    },
    horarios: {
      type: Array,
      require: true,
    },
    disciplinas: {
      type: Array,
    },
    allowedDates: {
      type: Function,
    },
  },
  data() {
    return {
      date: null,
      data: null,
      modal: false,
      menu: false,
      aulaDuplicada: {},
      confirmDialog: false,
      dataAulaDuplicada: null,
      objectModal: {
        title: "Duplicar aula",
        message: "Tem certeza que deseja duplicar esta aula?",
      },
      horarioSelecionado: {
        descricao: "Escolha um horario",
      },
      itemsEsperados: [
        { label: "Data", value: "dataAulaDuplicada" },
        { label: "Horário", value: "horarioSelecionado" },
      ],
      itemsPreenchidos: [],
      totalmentePreenchido: false,
    };
  },
  created() {
    // Cria um watcher para cada item esperado (value).
    this.itemsEsperados.forEach((item) => {
      this.$watch(item.value, (val) => {
        this.$toggleItemPreenchidoBarraProgresso(item.value, val, this.itemsPreenchidos);
      });
    });
  },
  watch: {
    form: {
      immediate: true,
      handler(val) {
        this.aulaDuplicada = val;
      },
    },
    dataAulaDuplicada(value) {
      if (!value) return;
      const date = new Date(value);
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(date);
      this.data = data_old.replaceAll("/", "/");
    },
  },
  methods: {
    enableSubmit() {
      if (!this.dataAulaDuplicada || !this.horarioSelecionado?.id) {
        this.$toast.danger("Preencha todos os campos obrigatórios: data e horário.");
        return;
      }
      this.confirmDialog = !this.confirmDialog;
      this.aulaDuplicada.data = this.dataAulaDuplicada;
    },
    async duplicarAula() {
      this.$loaderService.open("Duplicando a Aula");
      try {
        this.aulaDuplicada.horario_inicial = this.horarioSelecionado
          ? this.horarioSelecionado.inicio
          : null;
        this.aulaDuplicada.horario_final = this.horarioSelecionado
          ? this.horarioSelecionado.final
          : null;
        this.aulaDuplicada.horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;
        this.aulaDuplicada.gestao_de_aula = parseInt(this.$route.params.gestaoDeAulaId, 10);
        this.aulaDuplicada.disciplina_id = this.gestaoDeAulas.disciplina_id;
        this.aulaDuplicada.turma_id = this.gestaoDeAulas.turma_id;
        this.aulaDuplicada.instrutor_id = this.gestaoDeAulas.instrutor_id;
        await this.$services.aulasService.criar(this.aulaDuplicada);
        this.confirmDialog = !this.confirmDialog;
        this.$emit("dialogChange", false);
        this.$toast.success("Aula duplicada com sucesso!");
        // this.$router.push({ name: "aulas" });
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
    formatarQuebrasDeLinha(texto) {
      return texto ? texto.replace(/\n/g, "<br>") : "";
    },
    limparCampos() {
      this.data = null;
      this.dataAulaDuplicada = null;
      this.horarioSelecionado = null;
      this.totalmentePreenchido = false;
      this.$nextTick(() => {
        this.$refs.observer.reset();
      });
    },
  },
};
</script>
